
import { useState } from 'react';
import { Session } from '@supabase/supabase-js';
import { User } from '../../types';
import { SessionState } from './types';

export function useSessionState(): SessionState & {
  setUser: (user: User | null) => void;
  setSession: (session: Session | null) => void;
  setIsLoading: (isLoading: boolean) => void;
  setLastError: (error: Error | null) => void;
} {
  const [user, setUser] = useState<User | null>(null);
  const [session, setSession] = useState<Session | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [lastError, setLastError] = useState<Error | null>(null);

  return {
    user,
    session,
    isLoading,
    lastError,
    setUser,
    setSession,
    setIsLoading,
    setLastError
  };
}
